import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsAllSides21: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowsAllSides21"><Path d="M5 19H9V21H3V15H5V19Z" fill="currentColor"/><Path d="M21 21H15V19H19V15H21V21Z" fill="currentColor"/><Path d="M14 15H8V13H14V15Z" fill="currentColor"/><Path d="M16 11H8V9H16V11Z" fill="currentColor"/><Path d="M9 5H5V9H3V3H9V5Z" fill="currentColor"/><Path d="M21 9H19V5H15V3H21V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsAllSides21;
